module.exports = __webpack_public_path__ + "img/oa_banner3.7cfe9d1a.png";